import { GROUP_TYPE } from 'src/utils/config';
import { checkPhoneNumber } from 'src/api/checkout';
import { showDialog } from 'src/utils/error_config';

export function isOVO(id) {
  return ['XE_OVO', 'OVO'].includes(id);
}
export function calcPromo(str) {
  return str.split('==');
}
export function isPkg(type) {
  return type === GROUP_TYPE.PACKAGE;
}

export function checkPhone(val, vm) {
  return new Promise((resolve, reject) => {
    checkPhoneNumber({ phone: val })
      .then((res = {}) => {
        const { code, data } = res;
        if (code === 200) return resolve(true);
        if (code === 507) {
          showDialog(vm, 507);
          resolve(false);
        }
      })
      .catch((_) => resolve(false));
  });
}

export function checkEmailOptional(email, vm) {
  return new Promise((resolve, reject) => {
    const optional = vm.storeInfo.emailOptional;
    if (!optional && !email) {
      showDialog(vm, 8002);
      reject();
    } else { resolve() }
  })
}
